import React from "react";
import logoImage from "../assets/img/logo.png";

function HeaderLogo({ partnerName, imageData, isLoading }) {
  const imageSrc = imageData || logoImage;
  const name = (imageData ? partnerName : "Register to Vote PA") || "Register to Vote PA";

  return (
    <h1 className="leading-none">
      <a href="/">
        <img
          className="max-w-xs lg:max-w-sm block"
          alt={name}
          title={name}
          src={imageSrc}
          style={{ visibility: isLoading ? 'hidden' : 'visible' }}
        />
      </a>
    </h1>
  );
}

export default HeaderLogo;